import React, { memo } from 'react';

import { makeStyles } from '@mui/styles';
import SvgIcon from '@mui/material/SvgIcon';

const useStyles = makeStyles(({ typography }) => ({
  icon: {
    width: typography.pxToRem(14),
    height: typography.pxToRem(14),
    fillOpacity: '0.87',
  },
}));

const MixedAddRemove = () => {
  const styles = useStyles();

  return (
    <SvgIcon viewBox="0 0 13 13" className={styles.icon} fill="none">
      <g>
        <path d="M13 13V0L0 13H13Z" fill="#4C9C2E" />
        <path d="M13 0H0V13L13 0Z" fill="#DC0032" />
      </g>
    </SvgIcon>
  );
};

export default memo(MixedAddRemove);
